import { Routes } from '@common/constants';
import { IStepData } from '@common/interfaces';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppState {
  currentStep: number;
  salesRootUrl: string;
  stepData: IStepData[];
}

const initialState: AppState = {
  currentStep: 0,
  salesRootUrl: Routes.getSalesWizardPage(),
  stepData: [],
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    setSalesRootUrl: (state, action: PayloadAction<string>) => {
      state.salesRootUrl = action.payload;
    },
    setStepData: (state, action: PayloadAction<IStepData[]>) => {
      state.stepData = action.payload;
    },
  },
});

export const { setCurrentStep, setSalesRootUrl, setStepData } = appSlice.actions;
export default appSlice.reducer;
